import { useQuery } from '@apollo/client';
import { hllMode } from '@openx/types/segments.ts';
import { GetEnrichEstimateDocument } from '../../../graphql/query/audiences/GetEnrichEstimate.generated.tsx';
import { createSeedEstimatedReachND } from './utils/createSeedEstimatedReachND.ts';

export const useSegmentsEstimatedReachFetch = (ids: string[], skip?: boolean) => {
  const {
    loading,
    data: {
      enrichEstimate: { oaid: { reachTotal: OAID = 0 } = {} },
    } = {
      enrichEstimate: {},
    },
  } = useQuery(GetEnrichEstimateDocument, {
    skip,
    variables: {
      normalized_definition: createSeedEstimatedReachND(ids),
      hll_mode: hllMode.NO_SEGMENT_INTERSECTION,
    },
  });

  return { estimatedReach: OAID, loading };
};
